var _g, _path, _circle, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspectionformcardInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 217,
    viewBox: "0 0 300 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1221_6609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 10C15 7.23858 17.2386 5 20 5H249.636C250.838 5 252 5.433 252.909 6.21969L283.272 32.5046C284.37 33.4543 285 34.8338 285 36.2849V93.5V187C285 189.761 282.761 192 280 192H20C17.2386 192 15 189.761 15 187V10Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.646 37.9034C254.571 38.4745 251.733 36.1147 251.733 32.9875L251.733 4.99996L284.047 33L257.646 37.9034Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1221_6609",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 50,
    width: 173,
    height: 173
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 227.5,
    cy: 136.5,
    r: 86.5,
    fill: "#E5E5E5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.812 125.578V120H220.609C220.064 120 219.625 120.439 219.625 120.984V140.016C219.625 140.561 220.064 141 220.609 141H234.391C234.936 141 235.375 140.561 235.375 140.016V126.562H229.797C229.255 126.562 228.812 126.12 228.812 125.578ZM235.375 125V125.25H230.125V120H230.375C230.638 120 230.888 120.103 231.072 120.287L235.088 124.307C235.272 124.491 235.375 124.741 235.375 125Z",
    fill: "#E5E5E5"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1221_6609)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1221_6609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25732 2.16772C4.25732 -0.593707 6.4959 -2.83228 9.25732 -2.83228H247.391C248.593 -2.83228 249.755 -2.39928 250.663 -1.61258L282.23 25.7142C283.328 26.6639 283.958 28.0434 283.958 29.4945V88.8474V185.886C283.958 188.648 281.719 190.886 278.958 190.886H9.25733C6.4959 190.886 4.25732 188.648 4.25732 185.886V2.16772Z",
    fill: "#E5E5E5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1221_6609",
    x: 0,
    y: 0,
    width: 300,
    height: 217,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.658313 0 0 0 0 0.658313 0 0 0 0 0.658313 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1221_6609"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1221_6609",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1221_6609",
    x: -10.7427,
    y: -7.83228,
    width: 309.701,
    height: 223.719,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.658313 0 0 0 0 0.658313 0 0 0 0 0.658313 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1221_6609"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1221_6609",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectionformcardInactive);
export default __webpack_public_path__ + "static/media/inspectionformcard_inactive.569633c497051ed4ed6018af1a79dc12.svg";
export { ForwardRef as ReactComponent };